<template>
  <div>
    <label v-if="sourceFrom && sourceFrom != 'partnersummary'" :class="labelClass">{{$t(labelText)}}</label>
    <vueMultiSelect
      id="multiSelectSecondarySubCategory"
      class="field-headings mb-3"
      ref="multiSelectRef"
      v-model="selectedData"
      :position="position"
      :options="options"
      :selectOptions="optionFields"
      :search="true"
      @close="getSelectedValues($event)"
      :disabled="disabled"
      :btnLabel="btnLabelPrimaryCategory"
      @open="multiSelectOpened($event)"
      :multi="selectionType"
    />
  </div>
</template>

<script>
import vueMultiSelect from "vue-multi-select";

export default {
  props: [
    "defaultValue",
    "optionFields",
    "disabled",
    "labelText",
    "labelClass",
    "divClass",
    "position",
    "sourceFrom",
    "selectionType"
  ],
  components: {
    vueMultiSelect
  },
  watch: {
    defaultValue: function() {
      this.selectedData = this.defaultValue;
    }
  },
  created() {
    this.selectedData = this.defaultValue;
  },
  data() {
    return {
      // position: "bottom",
      selectedData: "",
      options: {
        multi: true,
        groups: false,
        labelList: "elements",
        groupName: "title",
        cssSelected: option =>
          option.selected
            ? {
                "background-color": "#ffffff"
              }
            : ""
      },
      btnLabelPrimaryCategory: values =>
        `Selected ${this.labelText} (${values.length})`
    };
  },
  methods: {
    getSelectedValues(event) {
      let selectedData = [];
      this.selectedData.forEach(element => {
        selectedData.push({ name: element.name, value: element.value });
      });
      console.log(selectedData)
      this.$emit("selectedMultiselectEvent", selectedData);
    },
    closeMultiSelect() {
      this.$refs.multiSelectRef.closeMultiSelect();
    },
    multiSelectOpened(event) {
      this.$emit("selectOpened", true);
    }
  }
};
</script>

<style scoped>
.select .checkboxLayer {
  position: relative !important;
}
.label-class {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.25;
  letter-spacing: normal;
  color: #777777;
  margin-bottom: 4% !important;
  float: left;
}
</style>
<style>
.select .checkboxLayer[data-v-293aad61] {
  width: 80% !important;
}
.margin-left-20[data-v-293aad61] {
  margin-left: 0% !important;
}
.select .selectItem[data-v-293aad61],
.select .selectItemDeactive[data-v-293aad61] {
  white-space: normal !important ;
  border-bottom: 1px solid #e6e6e6 !important;
}
</style>
